import { Spinner } from "react-bootstrap";

const SpinnerLoader = () => {
  return (
    <Spinner animation="border fs-xs mx-2" className="color-primary-dark" />
  );
};

export default SpinnerLoader;
